import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { usePricingColor } from './ColorContext';
import { Colors } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  emph: ({ color }: { color: Colors }) => ({
    color: theme.colorDefinitions[color].accessible,
  }),
}));

export const Emph = (props: any) => {
  const theme: Theme = useTheme();
  const color = usePricingColor();
  const classes = useStyles({ theme, color });

  return <span className={classes.emph} {...props} />;
};
